import {RepositoryNotLoading} from "./Repository";

const resource = 'v2/bank';

export default {
    account() {
        return RepositoryNotLoading.get(`${resource}/accounts`);
    }
};
